(() => {
  const init = () => {
    const root = document.getElementById('mybe-quick-cart');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const countNode = root.querySelector('#mqc-count');
    const priceNode = root.querySelector('#mqc-price');
    let previousCount = null;
    let latestRawCart = null;
    let emptyHideTimeout = null;

    // Reuse the theme's native cart-drawer trigger so its own drawer logic,
    // focus handling and overlay remain intact.
    const cartLink = root.querySelector('.mqc__inner');
    if (cartLink) {
      cartLink.addEventListener('click', (event) => {
        const drawerTrigger = document.querySelector(
          '.cart-drawer-button[aria-controls="CartDrawer"], [aria-controls="CartDrawer"].cart-drawer-button'
        );
        const drawer = document.getElementById('CartDrawer');

        if (drawerTrigger && drawer) {
          event.preventDefault();
          drawerTrigger.click();
        }
        // If this theme setting has no cart drawer, retain the normal /cart link.
      });
    }
    let flashTimeout = null;
    const notice = document.getElementById('mybe-cart-feedback');
    let noticeTimer;
    document.addEventListener('mybe:quick-add-error', () => {
      if (!notice) return;
      clearTimeout(noticeTimer);
      notice.textContent = root.dataset.updateError || '';
      notice.hidden = false;
      noticeTimer = setTimeout(() => { notice.hidden = true; }, 7000);
    });
    document.addEventListener('mybe:cart-confirmed', () => {
      if (notice && !notice.hidden) {
        clearTimeout(noticeTimer);
        noticeTimer = setTimeout(() => { notice.hidden = true; }, 7000);
      }
    });


    const money = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency || 'USD',
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `${currency || ''} ${((Number(cents) || 0) / 100).toFixed(2)}`.trim();
      }
    };

    const isPaymentFee = item => {
      const title = String(item.product_title || item.title || '').toLowerCase();
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      return title.includes('payment fee') || handle.includes('payment-fee');
    };

    const visibleCart = cart => {
      if (!cart) return cart;
      if (!Array.isArray(cart.items)) return cart;
      const feeItems = cart.items.filter(isPaymentFee);
      const visibleItems = cart.items.filter(item => !isPaymentFee(item));
      const feeTotal = feeItems.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
      return {
        ...cart,
        item_count: visibleItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
        // Preserve cart-level discounts and subtract only the hidden fee line.
        total_price: Math.max(0, Number(cart.total_price || 0) - feeTotal)
      };
    };

    const render = (rawCart, detectChange = true, forcedDirection = '', pending = false) => {
      if (!rawCart || typeof rawCart.item_count !== 'number') return;
      if (Array.isArray(rawCart.items)) {
        latestRawCart = rawCart;
        if (window.MybeCartWriteQueue) window.MybeCartWriteQueue.lastCart = rawCart;
      }
      const cart = visibleCart(rawCart);
      const count = Math.max(0, cart.item_count);
      const total = Number(cart.total_price) || 0;
      const direction = forcedDirection || (previousCount === null || !detectChange ? '' :
        count > previousCount ? 'added' : count < previousCount ? 'removed' : '');

      // The floating cart updates optimistically; no 'syncing' overlay or loading state.
      root.classList.remove('is-syncing');
      countNode.textContent = String(count);
      priceNode.textContent = money(total, cart.currency);
      // A floating cart containing 0 items must never linger on mobile.
      // Use the optimistic visible count immediately; no 560ms hold and no
      // 'pending' override when the customer removes the last item.
      clearTimeout(emptyHideTimeout);
      emptyHideTimeout = null;
      root.classList.toggle('is-visible', count > 0);

      // Only restart the color pulse when the confirmed/optimistic item count changes.
      // Duplicate cart events with the same count must not cancel or reverse the effect.
      if (direction) {
        clearTimeout(flashTimeout);
        // A successful new tap cancels any still-running yellow stock-limit flash.
        // Without this, .is-limit could visually override green/red on rapid taps.
        root.classList.remove('is-added', 'is-removed', 'is-limit');
        root.classList.add(direction === 'added' ? 'is-added' : 'is-removed');
        const inner = root.querySelector('.mqc__inner');
        const icon = root.querySelector('.mqc__icon');
        const count = root.querySelector('.mqc__count');
        [inner,icon,count].filter(Boolean).forEach((element,index) => {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof element.animate === 'function') {
            element._mybeQuickCartPulse?.cancel();
            element._mybeQuickCartPulse = element.animate(
              index === 1
                ? [{transform:'scale(1)'},{transform:direction === 'added' ? 'scale(1.12)' : 'scale(.92)'},{transform:'scale(1)'}]
                : [{transform:'scale(1)'},{transform:'scale(1.025)'},{transform:'scale(1)'}],
              {duration:330,easing:'cubic-bezier(.2,.8,.2,1)'}
            );
          }
        });
        flashTimeout = setTimeout(() => {
          root.classList.remove('is-added', 'is-removed');
        }, 520);
      } else if (previousCount === null) {
        clearTimeout(flashTimeout);
        root.classList.remove('is-added', 'is-removed');
      }
      previousCount = count;
    };



    // Instant visual response while the server request is still in flight.
    document.addEventListener('mybe:cart-optimistic', (event) => {
      const data = event.detail || {};
      if (typeof data.item_count !== 'number' || typeof data.total_price !== 'number') return;
      // The quick-add controller sends already-filtered visible totals here.
      // Do not subtract Payment Fees again: that would undercount the floating cart.
      render({
        item_count: Math.max(0, data.item_count),
        total_price: Math.max(0, data.total_price),
        currency: data.currency || latestRawCart?.currency || 'EGP'
      }, Boolean(data.direction), data.direction || '', true);
    });

    document.addEventListener('mybe:cart-confirmed', (event) => {
      const cart = event.detail && event.detail.cart;
      // The optimistic event already played the interaction feedback.
      // Confirmation only reconciles the final Shopify values; never replay the flash.
      if (cart) render(cart, false);
    });

    // Yellow warning feedback is reserved for attempts to add more than stock.
    document.addEventListener('mybe:cart-limit', () => {
      clearTimeout(flashTimeout);
      root.classList.remove('is-added', 'is-removed', 'is-limit');
      root.classList.add('is-limit');
      const inner = root.querySelector('.mqc__inner');
      const icon = root.querySelector('.mqc__icon');
      const count = root.querySelector('.mqc__count');
      [inner, icon, count].filter(Boolean).forEach((element, index) => {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && typeof element.animate === 'function') {
          element._mybeQuickCartPulse?.cancel();
          element._mybeQuickCartPulse = element.animate(
            index === 1
              ? [{transform:'scale(1)'},{transform:'scale(1.15)'},{transform:'scale(1)'}]
              : [{transform:'scale(1)'},{transform:'scale(1.035)'},{transform:'scale(1)'}],
            {duration:420,easing:'cubic-bezier(.2,.8,.2,1)'}
          );
        }
      });
      flashTimeout = setTimeout(() => root.classList.remove('is-limit'), 900);
    });

    // The theme publishes this event for product forms, bundles and cart quantity changes.
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (window.MybeCardQuickQty?.isBusy?.() && event?.source !== 'mybe-card-quick-qty') return;
        if (event && event.cart && !event.cart.errors) {
          if (event.source === 'mybe-card-quick-qty') return;
          render(event.cart, event.source !== 'cart-items');
        }
      });
    }

    // Also catch refreshes initiated by theme apps or custom cart scripts.
    document.addEventListener('cart:updated', (event) => {
      if (window.MybeCardQuickQty?.isBusy?.()) return;
      const cart = event.detail && (event.detail.cart || event.detail);
      const source = event.detail?.source || '';
      if (cart && source !== 'mybe-card-quick-qty' && source !== 'cart-items' && source !== 'cart-items-confirmed') {
        render(cart, true);
      } else if (cart) {
        render(cart, false);
      }
    });

    // Initial state; do not animate on page load.
    (window.MybeInitialCart?.load
      ? window.MybeInitialCart.load()
      : fetch(`${window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'}cart.js`, {
          headers: { Accept: 'application/json' }
        }).then(response => { if (!response.ok) throw new Error('Cart request failed'); return response.json(); }))
      .then(cart => {
        if (window.MybeCardQuickQty?.isBusy?.()) return;
        const actual = window.MybeCartWriteQueue?.lastCart;
        render(Array.isArray(actual?.items) ? actual : cart, false);
      })
      .catch(error => console.warn('[Mybe Quick Cart]', error));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
